import localforage from 'localforage';
import {
  ReactElement,
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react';
import { runInBackground } from '../util/async';
import { ObservableCache } from './observable-cache';

const ObservableCacheContext = createContext<ObservableCache | undefined>(
  undefined
);

const ObservableCacheProvider = ({ children }: { children: ReactElement }) => {
  const [observableCache, setObservableCache] = useState<
    ObservableCache | undefined
  >();

  useEffect(() => {
    runInBackground(async () => {
      const cache = localforage.createInstance({
        name: 'client-cache',
      });

      const observableCache = new ObservableCache(cache);

      await observableCache.restore();

      setObservableCache(observableCache);
    });
  }, []);

  return observableCache ? (
    <ObservableCacheContext.Provider value={observableCache}>
      {children}
    </ObservableCacheContext.Provider>
  ) : null;
};

const useObservableCache = (): ObservableCache => {
  return useContext(ObservableCacheContext) as ObservableCache;
};

export { useObservableCache, ObservableCacheProvider };
